import { render, staticRenderFns } from "./track2.vue?vue&type=template&id=96bb681c"
import script from "./track2.vue?vue&type=script&lang=js"
export * from "./track2.vue?vue&type=script&lang=js"
import style0 from "./track2.vue?vue&type=style&index=0&id=96bb681c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports